import PiiReferencePreviewActions from '../../references/actions/piiReferencePreviewActions';
import DoiReferencePreviewActions from '../../references/actions/doiReferencePreviewActions';
import EidReferencePreviewActions from '../../references/actions/eidReferencePreviewActions';
import AbstractContainer from '../../abstracts/abstractContainer';
import {
  createPiiEventData,
  createDoiEventData,
} from '../../../utils/trackers/createArticleEvents';
import { createNavigationClickEventData } from '../../../utils/trackers/adobe';

function getActions(pdfPath, identifiers, usageEventData) {
  const eventLocation = 'reference-panel';
  const { pii, doi, eid } = identifiers;

  if (pii) {
    const { savePdf, viewPdf } = createPiiEventData(eventLocation, usageEventData, pii);

    return (
      <PiiReferencePreviewActions
        pii={pii}
        pdfPath={pdfPath}
        savePdfEventData={savePdf}
        viewPdfEventData={viewPdf}
      />
    );
  }

  if (doi) {
    const { viewAtPublisher } = createDoiEventData(eventLocation);

    return (
      <DoiReferencePreviewActions
        doi={doi}
        viewAtPublisherEventData={viewAtPublisher}
      />
    );
  }

  if (eid) {
    const viewAtScopus = createNavigationClickEventData(eventLocation, 'scopus');

    return <EidReferencePreviewActions eid={eid} viewAtScopusEventData={viewAtScopus} />;
  }

  return null;
}

export default function referenceLink(context, content, key) {
  const {
    piiUnformatted: pii,
    pdfPath,
    scopusHubEid: eid,
    crossRefDoi: doi,
    'document-subtype': documentSubtype,
    contentType,
  } = content.$;
  const identifiers = { pii, eid, doi };
  const usageData = { documentSubtype, contentType };

  return (
    <div key={key}>
      {getActions(pdfPath, identifiers, usageData)}
      <AbstractContainer pii={pii} doi={doi} scopusEid={eid} />
    </div>
  );
}
